var _g, _g2, _g3, _g4, _g5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClappingHands(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "emoji",
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hair"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "skin"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FCEA2B",
    stroke: "#FCEA2B",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M56.3522,43.9976l-1.0617-7.4771c-0.5114-3.0215-0.8271-7.288-1.9002-14.2739c-2.4731-1.8145-5.4509,1.6502-6.2031,4.6336 L44.4345,8.9599c-0.5551-3.6134-7.1336-2.877-6.4499,1.5743l2.0868,14.0777L37.5421,7.6536 C36.9445,3.7633,30.4079,3.38,31.478,10.346c-0.5335-3.473-7.0838-3.4227-6.2808,1.8048l0.7744,5.4314l0.1014,0.8084l-0.221-1.6979 c-0.4806-3.1286-6.0705-2.3774-5.4508,1.6573l1.0803,6.4311"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCEA2B",
    d: "M22.7484,27.2535c-3.1923-3.1923,1.6882-7.6885,4.2795-5.0972l16.3092,16.3092l-3.4575-3.4575 c-1.1612-2.8574-0.8089-7.4235,2.2659-7.4235c5.01,5.01,8.4731,8.9333,10.6782,11.0721c6.2265,6.2265,6.2265,16.3217,0,22.5483 s-16.1868,6.2579-22.4133,0.0314L13.1717,43.9976c-2.8935-2.8935,1.1791-6.8155,3.4228-4.5718l9.8594,10.043l-8.5742-8.7339 l-4.5079-4.5918c-3.7489-3.7489,1.5155-7.6739,4.0062-5.1832c-4.9957-4.9957,0.5147-8.5621,3.3047-5.7722l13.3909,13.3909"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "skin-shadow"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "color"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 20.3603,
    x2: 20.6413,
    y1: 18.3415,
    y2: 20.1711,
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.4078,
    x2: 14.0603,
    y1: 12.9103,
    y2: 6.6237,
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.5067,
    x2: 6.5922,
    y1: 18.5051,
    y2: 21.0262,
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.6526,
    x2: 9.2139,
    y1: 15.5204,
    y2: 13.2187,
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 54.532,
    x2: 54.2702,
    y1: 14.4973,
    y2: 8.0732,
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 58.7358,
    x2: 65.092,
    y1: 19.1926,
    y2: 20.1602,
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56.8822,
    x2: 60.6073,
    y1: 16.5876,
    y2: 13.2524,
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29.9173,
    x2: 16.8352,
    y1: 43.7429,
    y2: 30.4172,
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34.0735,
    x2: 20.6826,
    y1: 38.5786,
    y2: 25.1877,
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M13.1717,43.9976c-2.8935-2.8935,1.1791-6.8155,3.4228-4.5718l9.8594,10.043"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M13.3717,36.1431c-3.7489-3.7489,1.5155-7.6739,4.0062-5.1832"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M20.6826,25.1877c-2.79-2.79-8.3004,0.7764-3.3047,5.7722"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M52.8236,38.6567c-2.2051-2.1389-5.6682-6.0622-10.6782-11.0721c-3.0748,0-3.4271,4.5661-2.2659,7.4235l3.4575,3.4575 L27.0279,22.1564c-2.5914-2.5914-7.4718,1.9049-4.2795,5.0972"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.3717,
    x2: 17.8796,
    y1: 36.1431,
    y2: 40.735,
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M52.8236,38.6567c6.2265,6.2265,6.2265,16.3217,0,22.5483s-16.1868,6.2579-22.4133,0.0314"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.1717,
    x2: 30.4103,
    y1: 43.9976,
    y2: 61.2363,
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 33.3873,
    x2: 31.3476,
    y1: 23.7062,
    y2: 9.5592,
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40.0786,
    x2: 37.5431,
    y1: 24.6186,
    y2: 7.6188,
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M20.3603,18.3415c-0.6213-4.0446,4.9823-4.7977,5.4641-1.6614l0.2215,1.702"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M25.1679,12.127c-0.805-5.2403,5.7614-5.2907,6.2962-1.8092"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M37.5431,7.6188c-0.5991-3.8999-7.1517-4.2841-6.079,2.6991"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M55.3349,36.5565c-0.5127-3.0289-0.8291-7.3059-1.9048-14.3089c-2.4791-1.8189-5.4643,1.6542-6.2183,4.6449L44.4524,8.9283 c-0.5564-3.6223-7.1511-2.8841-6.4657,1.5781"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25.1679,
    x2: 25.9442,
    y1: 12.127,
    y2: 17.5718,
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20.3603,
    x2: 20.6413,
    y1: 18.3415,
    y2: 20.1711,
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.4078,
    x2: 14.0603,
    y1: 12.9103,
    y2: 6.6237,
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.5067,
    x2: 6.5922,
    y1: 18.5051,
    y2: 21.0262,
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.6526,
    x2: 9.2139,
    y1: 15.5204,
    y2: 13.2187,
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 54.532,
    x2: 54.2702,
    y1: 14.4973,
    y2: 8.0732,
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 58.7358,
    x2: 65.092,
    y1: 19.1926,
    y2: 20.1602,
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56.8822,
    x2: 60.6073,
    y1: 16.5876,
    y2: 13.2524,
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClappingHands);
export default __webpack_public_path__ + "static/media/Clapping_Hands.bc6084b5cf94f8353a6e7827edc217e7.svg";
export { ForwardRef as ReactComponent };